// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list {
  height: calc(100% - 57px);
  overflow-y: auto;
}

ion-thumbnail {
  font-size: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.icon-environment {
  color: var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));
  transition: color 0.15s linear;
}

.container-environment-tabs {
  height: calc(100% - 61px);
}`, "",{"version":3,"sources":["webpack://./src/components/list-selectable/list-environment/list-environments.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,mEAAA;EACA,8BAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":["ion-list {\n  height: calc(100% - 57px);\n  overflow-y: auto;\n}\n\nion-thumbnail {\n  font-size: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.icon-environment{\n  color: var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));\n  transition: color .15s linear;\n}\n\n.container-environment-tabs{\n  height: calc(100% - 61px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
